import { Card, Descriptions, Image, Space, Tag, Typography } from 'antd';
import type { BarcodeKnowledge } from '../../api/barcodeScans';

interface Props {
  knowledge: BarcodeKnowledge;
  compact?: boolean;
}

const BarcodeKnowledgeCard: React.FC<Props> = ({ knowledge, compact = false }) => {
  const title = [knowledge.brand, knowledge.model_name || knowledge.good_name].filter(Boolean).join(' — ');
  const facts = [
    knowledge.container_size ? ['Фасовка', knowledge.container_size] : null,
    knowledge.manufacturer ? ['Производитель', knowledge.manufacturer] : null,
    knowledge.country ? ['Страна', knowledge.country] : null,
  ].filter((item): item is string[] => item !== null);
  const attributes = knowledge.attributes.slice(0, compact ? 4 : 12);

  return (
    <Card size="small" style={{ background: '#f6ffed', borderColor: '#b7eb8f' }}>
      <Space direction="vertical" size={8} style={{ width: '100%' }}>
        <Space size={6} wrap>
          <Tag color="green">Нацкаталог</Tag>
          {knowledge.good_status === 'draft' && <Tag color="orange">Черновик — проверьте данные</Tag>}
          {knowledge.good_status === 'withdrawn' && <Tag color="orange">Снята с публикации</Tag>}
        </Space>
        <Space align="start" size={12}>
          {knowledge.image_urls[0] && (
            <Image src={knowledge.image_urls[0]} alt="" width={72} height={72} style={{ objectFit: 'contain' }} />
          )}
          <div>
            <Typography.Text strong>{title || 'Товар найден'}</Typography.Text>
            {knowledge.description && (
              <Typography.Paragraph type="secondary" style={{ margin: '4px 0 0' }} ellipsis={{ rows: compact ? 2 : 4 }}>
                {knowledge.description}
              </Typography.Paragraph>
            )}
          </div>
        </Space>
        {(facts.length > 0 || attributes.length > 0) && (
          <Descriptions size="small" column={1} bordered={false}>
            {facts.map(([label, value]) => (
              <Descriptions.Item key={label} label={label}>{value}</Descriptions.Item>
            ))}
            {attributes.map((attribute, index) => (
              <Descriptions.Item key={`${attribute.id || attribute.name}-${index}`} label={attribute.name}>
                {attribute.value}{attribute.unit ? ` ${attribute.unit}` : ''}
              </Descriptions.Item>
            ))}
          </Descriptions>
        )}
      </Space>
    </Card>
  );
};

export default BarcodeKnowledgeCard;
